export default __webpack_public_path__ + "static/media/carta_objetivo.3fcaa00f.png";